
import MgpMessage from '../elements/MgpMessage/MgpMessage';

export default function UploadMobileConfirmPage() {

  return (
    <div className="entreprise-container">
        <h1 className="title mb-sm">MGP - Parcours d'affiliation</h1>
        <MgpMessage type="success" message="Votre document a été téléchargé, veuillez fermer cet onglet et continuer votre parcours sur votre navigateur principal" hasCloseBtn={false}/>
       
      </div>
  )
}